/**
 * Language Switcher Widget - Pill trigger + rounded dropdown
 * Toggle dropdown on trigger click; switch language on option click.
 */
(function() {
  'use strict';

  var widget = document.querySelector('[data-language-widget]');
  if (!widget) return;

  var trigger = widget.querySelector('[data-language-toggle]');
  var dropdown = widget.querySelector('[data-language-dropdown]');
  var form = widget.querySelector('.language-switcher-widget__form');
  var localeInput = widget.querySelector('[data-locale-input]');
  var options = widget.querySelectorAll('[data-language-option]');

  function openDropdown() {
    widget.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (dropdown) dropdown.removeAttribute('hidden');
  }

  function closeDropdown() {
    widget.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (dropdown) dropdown.setAttribute('hidden', '');
  }

  function switchLanguage(localeCode) {
    if (!localeInput || !form) return;
    var current = (localeInput.value || '').toLowerCase();
    var next = (localeCode || '').toLowerCase();
    if (next === current) {
      closeDropdown();
      return;
    }
    localeInput.value = localeCode;
    form.submit();
  }

  if (trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (widget.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });
  }

  if (options && options.length) {
    options.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var locale = btn.getAttribute('data-locale');
        if (locale) switchLanguage(locale);
      });
    });
  }

  document.addEventListener('click', function(e) {
    if (widget.classList.contains('is-open') && !widget.contains(e.target)) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && widget.classList.contains('is-open')) {
      closeDropdown();
      if (trigger) trigger.focus();
    }
  });
})();
